export const NoteCopyConfirm = (props, context) => {
  const store = context.root.$store
  const close = () => {
    context.emit('closeNoteCopyConfirm')
  }

  const action = () => {
    store
      .dispatch('note/copyNote')
      .then(() => {
        store.dispatch('note/reset')
        store.dispatch('note/getNoteLists')
        store.dispatch('note/getTags')
        store.dispatch('note/getUserLists')
        store.dispatch('note/getNoteCount')
        context.emit('closeNoteCopyConfirm')
      })
  }

  return {
    close,
    action
  }
}
